/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ai_Support_DescriptionInputs */

const et_service_ai_support_description = /** @type {(inputs: Service_Ai_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatiseer klienditeeninduse ja jäta ükski päring vastamata. Meie AI lahendused vastasid tõhusalt ja kodeeritud kõige paremini.`)
};

const en_service_ai_support_description = /** @type {(inputs: Service_Ai_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate customer service and never miss an inquiry again. Our AI solutions respond efficiently and intelligently.`)
};

/**
* | output |
* | --- |
* | "Automate customer service and never miss an inquiry again. Our AI solutions respond efficiently and intelligently." |
*
* @param {Service_Ai_Support_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_ai_support_description = /** @type {((inputs?: Service_Ai_Support_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ai_Support_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_ai_support_description(inputs)
	return en_service_ai_support_description(inputs)
});